<template>
  <div :class="$vuetify.breakpoint.mdAndUp ? 'pt-6 px-6' : 'pt-6'">
    <v-row justify="center" no-gutters>
      <div class="phone-box">
        <v-row justify="center" class="mt-6" no-gutters>
          <span class="phone-title">{{ $t("securityCheck.invoice") }}</span>
        </v-row>
        <v-row no-gutters class="mt-6 px-4" align="center">
          <span class="mr-1 checkout-h5 accent--text font-weight-bold">{{
            $t("general.tickets")
          }}</span>
          <span class="checkout-h5 accent--text font-weight-bold marked-text"
            >123</span
          >
          <v-spacer></v-spacer>
          <span class="accent--text checkout-h8" style="font-weight: 450"
            >R$ 99,90</span
          >
        </v-row>
        <v-row class="mt-2 px-4" justify="space-between" no-gutters>
          <div class="box1"></div>
          <div class="box2"></div>
        </v-row>
      </div>
    </v-row>

    <v-row class="mt-8" justify="center" no-gutters>
      <span class="checkout-h2 accent--text font-weight-bold">{{
        $t("securityCheck.authentication")
      }}</span>
    </v-row>

    <v-row class="mt-4" no-gutters justify="center">
      <span class="accent--text checkout-h3 text-center">{{
        $t("securityCheck.text")
      }}</span>
    </v-row>

    <v-row class="mt-6" no-gutters align="center" justify="center">
      <span class="checkout-h5 accent--text font-weight-bold mr-4"
        >PG*INGRESSOS</span
      >

      <v-text-field
        solo
        flat
        ref="first"
        background-color="#e7e9ec"
        class="text-field-square mr-4 elevation-0"
        v-model="firstDigit"
        @keydown="pressFirst"
        @input="checkIfAllFilled"
      ></v-text-field>
      <v-text-field
        solo
        flat
        ref="second"
        background-color="#e7e9ec"
        class="text-field-square mr-4"
        v-model="secondDigit"
        @keydown="pressSecond"
        @input="checkIfAllFilled"
      ></v-text-field>
      <v-text-field
        solo
        flat
        ref="third"
        background-color="#e7e9ec"
        class="text-field-square"
        v-model="thirdDigit"
        @keydown="pressThird"
        @input="checkIfAllFilled"
      ></v-text-field>
    </v-row>

    <v-row
      v-if="!showChangePaymentOption"
      justify="center"
      class="mt-6"
      no-gutters
    >
      <v-btn
        outlined
        rounded
        height="40"
        color="red"
        width="100%"
        @click="showChangePaymentOption = true"
        >{{ $t("securityCheck.cannotSee") }}</v-btn
      >
    </v-row>

    <v-row v-if="showChangePaymentOption" no-gutters class="mt-6">
      <div class="back-box pa-4">
        <v-row no-gutters>
          <span class="checkout-h5 font-weight-bold accent--text">{{
            $t("securityCheck.cannotSee")
          }}</span>
        </v-row>
        <v-row class="my-4" no-gutters>
          <span class="checkout-h5 accent--text"
            >{{ $t("securityCheck.cannotSeeTextOne") }}***{{
              buyer?.card_number?.split(" ")[3]
            }}{{ $t("securityCheck.cannotSeeTextTwo") }}</span
          >
        </v-row>
        <v-row no-gutters>
          <v-btn
            @click="back"
            height="40"
            rounded
            width="100%"
            depressed
            :loading="loading"
            dark
            color="red"
            >{{ $t("securityCheck.changePaymentMethod") }}</v-btn
          >
        </v-row>
      </div>
    </v-row>

    <v-row class="mt-6" no-gutters>
      <span class="checkout-h5 accent--text font-weight-bold">
        {{ $t("securityCheck.whySeeing") }}
      </span>
    </v-row>
    <v-row no-gutters>
      <span class="checkout-h5 accent--text">
        {{ $t("securityCheck.becauseSeeing") }}</span
      >
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      firstDigit: "",
      secondDigit: "",
      thirdDigit: "",
      loading: false,
      showChangePaymentOption: false,
    };
  },
  mounted() {
    this.focusOnFirst();
    localStorage.setItem(
      `wait-authentication-${this.eventId}`,
      JSON.stringify({
        finalDetails: this.finalDetails,
        buyer: this.buyer,
      })
    );
  },
  computed: {
    ...mapGetters([
      "buyer",
      "orderDetails",
      "finalDetails",
      "buyer",
      "eventId",
    ]),
  },
  watch: {
    firstDigit(v) {
      if (v && v.length === 1) this.$refs.second.focus();
    },
    secondDigit(v) {
      if (v && v.length === 1) this.$refs.third.focus();
    },
  },
  methods: {
    async back() {
      this.loading = true;
      let params = {
        hash_pedido: this.orderDetails.hash_pedido,
        desistencia: true,
      };
      await this.$store.dispatch("confirmTokenOrder", params);
      this.$store.commit("SHOW_SECURITY_CHECK", false);
      localStorage.removeItem(`wait-authentication-${this.eventId}`);
      this.loading = false;
    },

    pressFirst(e) {
      if (this.firstDigit && e.keyCode !== 8) {
        e.preventDefault();
      }
    },

    pressSecond(e) {
      if (this.secondDigit && e.keyCode !== 8) {
        e.preventDefault();
      } else if (!this.secondDigit && e.keyCode === 8) this.$refs.first.focus();
    },

    pressThird(e) {
      if (this.thirdDigit && e.keyCode !== 8) {
        e.preventDefault();
      } else if (!this.thirdDigit && e.keyCode === 8) this.$refs.second.focus();
    },

    focusOnFirst() {
      setTimeout(() => {
        this.$refs.first.focus();
      }, 300);
    },

    clearFields() {
      this.firstDigit = "";
      this.secondDigit = "";
      this.thirdDigit = "";
      this.focusOnFirst();
    },

    async checkIfAllFilled() {
      if (this.firstDigit && this.secondDigit && this.thirdDigit) {
        let params = {
          hash_pedido: this.orderDetails.hash_pedido,
          token: this.firstDigit + this.secondDigit + this.thirdDigit,
          desistencia: false,
        };
        await this.$store
          .dispatch("confirmTokenOrder", params)
          .then((resp) => {
            if (resp?.status === 200) {
              this.$store.dispatch("openSnackbar", {
                message: "Pagamento confirmado com sucesso!",
                color: "success",
              });
              this.$router.push({
                name: "Finished",
                params: { event: this.eventId },
                query: this.$route.query,
              });
              localStorage.removeItem(`wait-authentication-${this.eventId}`);
            } else if (resp?.response?.status === 410) {
              this.goCart();
            } else {
              this.clearFields();
            }
          })
          .catch(() => {
            this.$store.dispatch("openSnackbar", {
              message: "Erro Inesperado",
              color: "error",
            });
            this.clearFields();
          });
      }
    },
    async goCart() {
      this.$router.push({
        name: "Cart",
        params: { event: this.eventId },
        query: this.$route.query,
      });
      this.$store.dispatch("resetCheckout", this.eventId);
      await this.$store.dispatch("getProductsAndSectors", {
        event: this.eventId,
        coupon: this.$route.query.c,
      });
    },
  },
};
</script>

<style scoped>
.phone-box {
  border: 10px solid black;
  border-bottom: none;
  border-top-right-radius: 50px;
  border-top-left-radius: 50px;
  width: 236px;
  height: 136px;
  box-shadow: 0px 4px 8px rgba(176, 190, 197, 0.24);
}

.phone-title {
  font-weight: 700;
  font-size: 18px;
  line-height: 23px;
  color: #a3aab5;
}

.marked-text {
  background: rgba(255, 87, 34, 0.32);
  border-radius: 4px;
  padding: 0.2px 3px;
}

.box1 {
  width: 111px;
  height: 15px;
  background: #dadada;
  opacity: 0.5;
  border-radius: 100px;
}

.box2 {
  width: 44px;
  height: 15px;
  background: #dadada;
  opacity: 0.5;
  border-radius: 100px;
}

.text-field-square {
  max-width: 48px;
  max-height: 48px;
}

.back-box {
  background: rgba(211, 55, 36, 0.12);
  border-radius: 8px;
}
</style>
